// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* DashboardLayout.css */
.dashboard-layout {
  display: block;
  min-height: 100vh;
  background-color: rgba(151, 71, 255, 0.0784313725);
  position: relative;
  z-index: 1;
}

/*style for side navigation bar*/
.side-nav {
  position: fixed !important;
  left: 0;
  top: 3.76vw;
  height: 100%;
  width: 17.16vw;
  z-index: 100;
  transition: all 0.5s ease;
  background: linear-gradient(191.14deg, #EE3A24 39.22%, #9747FF 65.37%);
}

.side-nav:after {
  content: "";
  position: absolute;
  width: 100%;
  height: 100%;
  top: 0;
  background: radial-gradient(100% 100% at 0% 0%, rgba(255, 255, 255, 0.4) 0%, rgba(255, 255, 255, 0) 100%);
  z-index: -1;
}

.side-nav ul {
  list-style-type: none;
  padding: 0;
  display: contents;
}

.side-nav li:first-child {
  margin-top: 1.11vw;
}

.side-nav li {
  margin: 0.555vw 1.24875vw;
}

.side-nav.close li {
  margin: 1.31868vw 0.62vw;
  transition: all 0.4s ease;
}

.side-nav li.active_link, .side-nav li.active_link:hover {
  background-color: #fff;
  border-radius: 3px;
}

.side-nav li:hover {
  background-color: rgba(255, 255, 255, 0.2);
  border-radius: 3px;
}

.side-nav li a:nth-child(1) svg {
  filter: brightness(0) invert(1);
}

.side-nav li.active_link a svg {
  filter: invert(0) sepia(0) saturate(0) hue-rotate(0) brightness(0) contrast(97%);
}

.side-nav li.active_link a {
  color: #000;
}

.side-nav li a {
  color: #fff;
  text-decoration: none;
  padding: 0.69375vw;
}

.side-nav.close {
  width: 4.30125vw;
  display: block !important;
}

.side-nav .nav-links {
  height: 100%;
  overflow: auto;
}

.side-nav.close .nav-links {
  overflow: visible;
}

.side-nav.close li {
  display: flex;
  align-items: center;
  justify-content: center;
}

.side-nav .nav-links::-webkit-scrollbar {
  display: none;
}

.side-nav .nav-links li {
  position: relative;
  list-style: none;
  transition: all 0.4s ease;
}

.side-nav .nav-links li a {
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 1.3875vw;
}

.side-nav .nav-links li a svg {
  margin: 0 0.555vw 0 0;
}

.side-nav.close .nav-links li a {
  justify-content: center;
}

.side-nav.close .nav-links li a svg {
  margin: 0;
}

.side-nav .nav-links li a .link_name {
  font-size: 0.90243vw;
  transition: all 0.4s ease;
  width: calc(100% - 30px);
  display: inline-block;
}

.side-nav.close .nav-links li a .link_name {
  opacity: 0;
  pointer-events: none;
}

.side-nav.close .nav-links li a span {
  display: none;
}

.home-section {
  position: relative;
  left: 17.16vw;
  transition: all 0.5s ease;
  flex: 1 1;
  padding: 3.816vw 0;
}

.side-nav ~ .home-section {
  width: 82.55625vw;
}

.main-content {
  margin: 2.92vw 5.035vw;
}

.side-nav.close ~ .home-section {
  left: 4.30125vw;
  width: 95.07483vw;
}

.blur {
  filter: blur(5px);
}`, "",{"version":3,"sources":["webpack://./src/style/components/dashboard/Dashboard.scss"],"names":[],"mappings":"AAAA,wBAAA;AACA;EACI,cAAA;EACA,iBAAA;EACA,kDAAA;EACA,kBAAA;EACA,UAAA;AACJ;;AACE,gCAAA;AACA;EACE,0BAAA;EACD,OAAA;EACA,WAAA;EACC,YAAA;EACA,cAAA;EACA,YAAA;EACA,yBAAA;EACA,sEAAA;AAEJ;;AAAE;EACE,WAAA;EACA,kBAAA;EACA,WAAA;EACA,YAAA;EACA,MAAA;EACA,yGAAA;EACA,WAAA;AAGJ;;AAAE;EACE,qBAAA;EACA,UAAA;EACA,iBAAA;AAGJ;;AADE;EACE,kBAAA;AAIJ;;AAFE;EACE,yBAAA;AAKJ;;AAHE;EACE,wBAAA;EACA,yBAAA;AAMJ;;AAHE;EACE,sBAAA;EACA,kBAAA;AAMJ;;AAJE;EACE,0CAAA;EACA,kBAAA;AAOJ;;AAHE;EACE,+BAAA;AAMJ;;AAJE;EACE,gFAAA;AAOJ;;AALE;EACA,WAAA;AAQF;;AANE;EACE,WAAA;EACC,qBAAA;EACA,kBAAA;AASL;;AANE;EACE,gBAAA;EACA,yBAAA;AASJ;;AANE;EACE,YAAA;EACA,cAAA;AASJ;;AAPE;EACE,iBAAA;AAUJ;;AARE;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;AAWJ;;AANE;EACE,aAAA;AASJ;;AAPE;EACE,kBAAA;EACA,gBAAA;EACA,yBAAA;AAUJ;;AARE;EACC,aAAA;EACA,mBAAA;EACD,8BAAA;EAEA,gBAAA;AAUF;;AAPE;EACE,qBAAA;AAUJ;;AARE;EACE,uBAAA;AAWJ;;AATE;EACE,SAAA;AAYJ;;AAVE;EACE,oBAAA;EACA,yBAAA;EACA,wBAAA;EACA,qBAAA;AAaJ;;AAXE;EACE,UAAA;EACA,oBAAA;AAcJ;;AAZE;EACE,aAAA;AAeJ;;AAbE;EACE,kBAAA;EACA,aAAA;EACA,yBAAA;EACE,SAAA;EACA,kBAAA;AAgBN;;AAdE;EACE,iBAAA;AAiBJ;;AAdE;EACE,sBAAA;AAiBJ;;AAdE;EACE,eAAA;EACA,iBAAA;AAiBJ;;AAfE;EACE,iBAAA;AAkBJ","sourcesContent":["/* DashboardLayout.css */\n.dashboard-layout {\n    display: block;\n    min-height: 100vh;\n    background-color: #9747FF14;\n    position: relative;\n    z-index: 1;\n  }\n  /*style for side navigation bar*/ \n  .side-nav {\n    position: fixed!important;\n   left: 0;\n   top:3.76vw;\n    height: 100%;\n    width: 17.16vw; \n    z-index: 100;\n    transition: all 0.5s ease;\n    background: linear-gradient(191.14deg, #EE3A24 39.22%, #9747FF 65.37%);\n  }\n  .side-nav:after {\n    content: '';\n    position: absolute;\n    width: 100%;\n    height: 100%;\n    top: 0;\n    background: radial-gradient(100% 100% at 0% 0%, rgba(255, 255, 255, 0.4) 0%, rgba(255, 255, 255, 0) 100%);\n    z-index: -1;\n}\n  \n  .side-nav ul {\n    list-style-type: none; \n    padding: 0;\n    display: contents;\n  }\n  .side-nav li:first-child {\n    margin-top: 1.11vw;\n  }\n  .side-nav li {\n    margin: 0.555vw 1.24875vw;\n  }\n  .side-nav.close li {\n    margin: 1.31868vw .62vw;\n    transition: all 0.4s ease;\n}\n  \n  .side-nav li.active_link,.side-nav li.active_link:hover {\n    background-color: #fff;\n    border-radius: 3px;\n  }\n  .side-nav li:hover{\n    background-color: rgba(255, 255, 255, 0.2);\n    border-radius: 3px;\n    \n  }\n  \n  .side-nav li a:nth-child(1) svg{\n    filter: brightness(0) invert(1);\n  }\n  .side-nav li.active_link a svg{\n    filter: invert(0) sepia(0) saturate(0) hue-rotate(0) brightness(0) contrast(97%);\n  }\n  .side-nav li.active_link a {\n  color: #000;\n  }\n  .side-nav li a {\n    color: #fff; \n     text-decoration: none; \n     padding: 0.69375vw;\n  }\n\n  .side-nav.close {\n    width: 4.30125vw;   \n    display: block!important;\n  }\n  \n  .side-nav .nav-links {\n    height: 100%;\n    overflow: auto;\n  }\n  .side-nav.close .nav-links {\n    overflow: visible;  \n  }\n  .side-nav.close li {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    // text-align: center;\n    \n  }\n \n  .side-nav .nav-links::-webkit-scrollbar {\n    display: none;\n  }\n  .side-nav .nav-links li {\n    position: relative;\n    list-style: none;\n    transition: all 0.4s ease;\n  }\n  .side-nav .nav-links li a {\n   display: flex;\n   align-items: center;\n  justify-content: space-between;\n  //width: 1.3875vw;\n  height: 1.3875vw;\n\n  }\n  .side-nav .nav-links li a svg{\n    margin: 0 0.555vw 0 0;\n  }\n  .side-nav.close .nav-links li a{\n    justify-content: center;\n  }\n  .side-nav.close .nav-links li a svg{\n    margin: 0;\n  }\n  .side-nav .nav-links li a .link_name {\n    font-size: 0.90243vw;\n    transition: all 0.4s ease;\n    width: calc(100% - 30px);\n    display: inline-block;\n  }\n  .side-nav.close .nav-links li a .link_name {\n    opacity: 0;\n    pointer-events: none;\n  }\n  .side-nav.close .nav-links li a span{\n    display: none; \n  }\n  .home-section {\n    position: relative;\n    left: 17.16vw;\n    transition: all 0.5s ease; \n      flex: 1; \n      padding: 3.816vw 0;\n  }\n  .side-nav ~ .home-section{\n    width: 82.55625vw;\n   \n  }\n  .main-content{\n    margin:2.92vw 5.035vw;\n  }\n  \n  .side-nav.close ~ .home-section {\n    left: 4.30125vw;\n    width: 95.07483vw;\n  }\n  .blur{\n    filter: blur(5px);\n  }"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
